import { observable, computed, action, runInAction } from 'mobx';
import autobind from 'autobind-decorator';
import { asyncAction } from 'mobx-utils';
import { ScoreService } from 'services';
import VolleyballModel from './model';
import useLocalStorage from 'hooks/useLocalStorage';
import { ScoreUtil } from 'utils/scoreUtil';
import WebSocketUtil from 'utils/socketUtil';
import { timeUtils } from 'utils/timeUtil';
import AbstractScoreCommon from '../../store/common';

@autobind
class VolleyballStore extends AbstractScoreCommon {
  socket = null;
  isSub = false;

  @observable
  list = [];

  @observable
  loading = false;

  @observable
  selectedTab = 'ALL';

  constructor() {
    super();
  }

  connectSocket(topic) {
    this.socket = new WebSocketUtil(topic);

    this.socket.ws.onmessage = (event) => {
      if (event) {
        let data = event.data;

        try {
          if (data === 'OK') {
            this.isSub = true;
          } else {
            let messageData = JSON.parse(data);

            if (messageData) {
              const { TOPIC, MESSAGE } = messageData;

              if (TOPIC.includes('sports')) {
                const data = JSON.parse(MESSAGE);
                const copy = [...this.list.toJS()];
                let index = -1;

                if (data.hasOwnProperty('gameId')) {
                  index = copy.findIndex((item) => item.id === data.gameId);
                }

                if (Boolean(~index)) {
                  if (TOPIC === `sports.volleyball.games`) {
                    const check = this.isFavoriteActiveCheck;
                    const checkFavorite = this.selectedList.some(
                      (item) => item.id === data.gameId
                    );

                    this.list[index].updateGame(
                      data.game,
                      check,
                      checkFavorite
                    );
                  }

                  if (TOPIC === `sports.volleyball.period-data`) {
                    this.list[index].updatePeriodData(data.periodData);
                  }

                  if (TOPIC === `sports.volleyball.special`) {
                    this.list[index].updateSpecial(data.special);
                  }

                  if (TOPIC === `sports.volleyball.last-broadcast`) {
                    this.list[index].updateLastBroadcast(data.broadcast);
                  }

                  if (TOPIC === `sports.volleyball.period-special`) {
                    this.list[index].updatePeriodSpecial(data.periodSpecial);
                  }
                }

                if (TOPIC === `sports.volleyball.cheers`) {
                  index = copy.findIndex(
                    (item) => item.id === parseInt(data.game_id)
                  );
                  if (Boolean(~index)) {
                    this.list[index].cheerCount++;
                  }
                }
              }
            }
          }
        } catch (error) {
          console.log('=== socket on message error ===', error);
        }
      }
    };
  }

  /**********************************************************
   * computed
   **********************************************************/
  @computed
  get volleyballList() {
    const list = this.list.toJS();
    const selectedTab = this.selectedTab;
    const filterList =
      selectedTab === 'ALL'
        ? list
        : list.filter((item) => {
            if (selectedTab === 'READY') {
              return item.gameStatus === 'READY';
            } else if (selectedTab === 'PROGRESS') {
              return (
                item.gameStatus === 'IN_PROGRESS' ||
                item.gameStatus === 'BREAK_TIME' ||
                item.gameStatus === 'PAUSE'
              );
            } else if (selectedTab === 'FINAL') {
              return (
                item.gameStatus === 'FINAL' ||
                item.gameStatus === 'CUT' ||
                item.gameStatus === 'POSTPONED' ||
                item.gameStatus === 'PENDING' ||
                item.gameStatus === 'CANCEL' ||
                item.gameStatus === 'DELAY' ||
                item.gameStatus === 'SUSPENDED'
              );
            }
          });

    let deleteSelectedGames = [];

    if (this.selectedGames.length > 0) {
      deleteSelectedGames = filterList.filter((item) =>
        this.selectedGames.every((id) => item.id !== id.key)
      );
    } else {
      deleteSelectedGames = filterList;
    }

    return ScoreUtil.sortSportsList(deleteSelectedGames);
  }

  @computed
  get selectedList() {
    const list = this.list.toJS();
    let selectedGameList = [];

    if (this.selectedGames.length > 0) {
      selectedGameList = list.filter((item) =>
        this.selectedGames.some((id) => id.key === item.id)
      );
    }

    return ScoreUtil.sortSportsList(selectedGameList);
  }

  @computed
  get volleyballCount() {
    const list = this.list.toJS();

    return {
      all: list.length,
      ready: list.filter((item) => item.gameStatus === 'READY').length,
      inProgress: list.filter(
        (item) =>
          item.gameStatus === 'IN_PROGRESS' ||
          item.gameStatus === 'BREAK_TIME' ||
          item.gameStatus === 'PAUSE'
      ).length,
      final: list.filter(
        (item) =>
          item.gameStatus === 'FINAL' ||
          item.gameStatus === 'CUT' ||
          item.gameStatus === 'POSTPONED' ||
          item.gameStatus === 'PENDING' ||
          item.gameStatus === 'CANCEL' ||
          item.gameStatus === 'DELAY' ||
          item.gameStatus === 'SUSPENDED'
      ).length
    };
  }

  @computed
  get isFavoriteActiveCheck() {
    const { selectedList } = this;

    return selectedList.length > 0;
  }

  /**********************************************************
   * actions
   **********************************************************/
  @action
  closeSocket() {
    this.socket.close(() => {
      runInAction(() => {
        this.isSub = false;
        this.socket = null;
      });
    });
  }

  @action
  setVolleyballSelectedTab(tab) {
    this.selectedTab = tab;
  }

  /**********************************************************
   * async actions
   **********************************************************/
  @asyncAction
  *getVolleyball(date) {
    this.loading = true;

    try {
      // TODO: 웹소켓;
      if (!this.isSub) {
        yield this.connectSocket([
          'sports.volleyball.games',
          'sports.volleyball.period-data',
          'sports.volleyball.last-broadcast',
          'sports.volleyball.special',
          'sports.volleyball.period-special',
          'sports.volleyball.cheers'
        ]);
      }

      const result = yield ScoreService.getSportsTypeGames(
        date,
        'ALL',
        'volleyball'
      );

      if (result) {
        this.list = result.map((item) => new VolleyballModel(item));

        this.loading = false;
      }

      // console.log('result success = ', result);
      // console.log(type, ' response = ', this.sports[type]);
    } catch (error) {
      console.log(error);
    }
  }
}

export default VolleyballStore;
